/*
 * @Author: 'qhy' '272921690@qq.com'
 * @Date: 2022-10-29 13:08:35
 * @LastEditors: 'qhy' '272921690@qq.com'
 * @LastEditTime: 2023-03-14 09:58:39
 * @FilePath: \edu_ytsr_show_total_vue\src\utils\mixin.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const mixin = {
  methods: {
    
    navClick(params, index) {
      if (index == 7) {
        this.showLogin = true
      }
      this.$store.commit('set_nav_index', index)
      if (params.href) {
        if (params.is_redirect) {
          window.open(params.href)
        } else {
          // 判断面包屑中地图是否存在如果不存在插入
          const is_path = this.$store.state.breadList.find((item) => {
            return item.path === params.href
          })
          if (!is_path) {
            this.$store.commit('addBread', { path: params.href, title: params.name })
          }
          this.$router.push(params.href)
        }
      }
    }
  }
}
export default mixin